import { memo } from 'react';
import UISkeleton from '@mui/material/Skeleton';

import styles from './question-pills.scss';

const PillsLoadingSkeleton = ({ isMobile }) => {
  if (isMobile)
    return (
      <>
        <div className={styles.skeleton}>
          <UISkeleton variant="rectangular" width="150px" height="30px" />
        </div>
        <div className={styles.skeleton}>
          <UISkeleton variant="rectangular" width="150px" height="30px" />
        </div>
      </>
    );

  return (
    <>
      <div className={styles.skeleton}>
        <UISkeleton variant="rectangular" width="213px" height="30px" />
      </div>
      <div className={styles.skeleton}>
        <UISkeleton variant="rectangular" width="213px" height="30px" />
      </div>
      <div className={styles.skeleton}>
        <UISkeleton variant="rectangular" width="135px" height="30px" />
      </div>
    </>
  );
};

export default memo(PillsLoadingSkeleton);
